import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA,MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { RestrictedWordService } from '../restricted-word.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-edit-restricted-word',
  templateUrl: './add-edit-restricted-word.component.html',
  styleUrls: ['./add-edit-restricted-word.component.css']
})
export class AddEditRestrictedWordComponent implements OnInit {
  referance :any
  constructor(    private restrictedWordService:RestrictedWordService
    ,private dialogRef : MatDialogRef<AddEditRestrictedWordComponent>, 
    @Inject(MAT_DIALOG_DATA)data)
     { 

    this.referance= data
   } 


   form: FormGroup = new FormGroup({

  
    id: new FormControl(0),
    restrictedText:new FormControl ('', Validators.required)
  })

  ngOnInit() {

    if(this.referance.id!=0){
      this.form.patchValue(this.referance)
    }
  }



  submit(){
    if (this.form.invalid) { return this.form.markAllAsTouched(); }

    this.restrictedWordService.upsertRestrictWord(this.form.value).subscribe((res:any)=>{
      if(this.form.get('id').value == 0 ){
        this.restrictedWordService.openNotifySuccess('Saved successfully  ')
        this.dialogRef.close('done')

      }else{
        this.restrictedWordService.openNotifySuccess('Updated successfully  ')
        this.dialogRef.close('done')


      }
    }),err=>{
      this.restrictedWordService.openNotifyError(err.error.message)

    }

  }



  declined() {
    this.dialogRef.close();
  }
}
